/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import {
  InboxOutlined,
  PlusOutlined,
  CloseCircleFilled,
  CopyrightOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Modal,
} from "antd";
import { Input, Row, Select, Space, Typography, Upload } from "antd";
import dayjs from "dayjs";
import {
  BOOKING_ROOMS,
  CREATE_BOOKING,
  FILE_DESTROY,
  FILE_UPLOAD,
  IMAGE_BASE_URL,
  LOCATIONS,
  USER_DETAIL_MOBILE,
} from "../../../constants/api";
import { displayMessage, getAPI, postAPI } from "../../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../../constants/messages";
import {
  BUSINESS_SEGMENT,
  calculateTotalBill,
  CURRENCY,
  getGstRateAndAmount,
  getInclusiveGstRateAndAmount,
  getRoomTypeLabel,
  getServiceLabel,
  PAYMENT_METHOD,
} from "../../../constants/constent";

const { Dragger } = Upload;
const { Option } = Select;
const { Title } = Typography;

const ReservationForm = ({
  room = null,
  date = null,
  booking_type = "booking",
}) => {
  const today = dayjs();
  const [form] = Form.useForm();
  const rooms_watch = Form.useWatch("rooms", form);
  const previousRooms = useRef([]);

  const [fileList, setFileList] = useState([]);
  const [checkinDate, setCheckinDate] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [oldDocID, setOldDocID] = useState(null);
  const [checkoutDate, setCheckoutDate] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDays, setTotalDays] = useState(0);

  const [loading, setLoading] = useState(false);

  // Rooms
  const [rooms, setRooms] = useState({});
  const [gstBillSummery, setGstBillSummery] = useState(
    calculateTotalBill(
      form.getFieldValue("rooms") || [],
      rooms || [],
      totalDays,
      0,
    ),
  );
  // Locations
  const [country, setCountry] = useState(null);
  const [countryID, setCountryID] = useState(102);
  const [state, setState] = useState(null);
  const [stateID, setStateID] = useState(null);
  const [city, setCity] = useState(null);

  const getInitValue = () => {
    const checkin = date ? dayjs(date) : today;
    const checkout = date ? dayjs(date).add(1, "day") : today.add(1, "day");
    form.setFieldsValue({
      booking_segment: BUSINESS_SEGMENT[0].value,
      advance_amount: 0,
      checkin_date: checkin,
      checkout_date: checkout,
      country_id: countryID ?? 102,
    });

    let rooms = form.getFieldValue("rooms") || [];
    rooms = rooms.filter((room) => Object.keys(room).length > 0);
    form.setFieldsValue({ rooms });
    if (!rooms.length) {
      handleAddRoom();
    }
    getLocations(countryID ?? 102, stateID);
    setCheckinDate(checkin);
    setCheckoutDate(checkout);
    handleDateChange(checkin, checkout);
    getData();
  };

  const calculateTotal = () => {
    let gstBillSummery = calculateTotalBill(
      form.getFieldValue("rooms") || [],
      rooms || [],
      totalDays,
      0,
    );
    setGstBillSummery(gstBillSummery);
    setTotalAmount(gstBillSummery.summary.grandTotal);
    form.setFieldsValue({
      sub_total_amount: gstBillSummery.summary.totalBase,
      total_amount: gstBillSummery.summary.grandTotal,
      gst_amount: gstBillSummery.summary.totalGst,
    });
  };

  useEffect(() => {
    calculateTotal();
  }, [rooms_watch, form, totalDays, checkinDate, checkoutDate]);

  useEffect(() => {
    if (!rooms_watch) return;

    rooms_watch.forEach((room, index) => {
      const prevRoom = previousRooms.current[index] || {};

      // Compare previous vs current to detect change
      if (room.room_price !== prevRoom.room_price) {
        const t_rate_amount = getGstRateAndAmount(room.room_price, totalDays);

        const updatedRooms = [...rooms_watch];
        updatedRooms[index] = {
          ...room,
          gst_rate: t_rate_amount.gstRate,
          gst_amt: t_rate_amount.gstAmount,
        };

        form.setFieldsValue({ rooms: updatedRooms });
      }
    });

    // Update previous reference
    previousRooms.current = rooms_watch;
  }, [rooms_watch, totalDays]);

  useEffect(() => {
    const checkin = date ? dayjs(date) : today;
    const checkout = date ? dayjs(date).add(1, "day") : today.add(1, "day");
    console.log("Getting This Params", room, date, booking_type);

    setLoading(true);
    if (room) {
      let rooms = form.getFieldValue("rooms") || [];
      if (rooms.length > 0) {
        rooms = rooms.filter((room) => Object.keys(room).length > 0);
        form.setFieldsValue({ rooms });
      }
      const roomExists = rooms.some(
        (existingRoom) => existingRoom.room_id === room.id,
      );
      console.log("Room Exist Check: ", roomExists, rooms, room);

      const diffInTime = checkout.valueOf() - checkin.valueOf();
      const diffInDays = diffInTime / (1000 * 3600 * 24);

      const days = diffInDays === 0 ? 1 : diffInDays;

      setTotalDays(days);

      const t_rate_amount = getGstRateAndAmount(room.room_amt, days);

      if (roomExists === false) {
        if (room?.rate_plans) {
          setRoomService((prev) => {
            const existingPlans = prev?.[room.group_id] || [];

            const mergedPlans = [
              ...existingPlans,
              ...room.rate_plans.filter(
                (newPlan) =>
                  !existingPlans.some((oldPlan) => oldPlan.id === newPlan.id),
              ),
            ];

            return {
              ...(prev || {}),
              [room.group_id]: mergedPlans,
            };
          });
        }
        form.setFieldsValue({
          rooms: [
            ...rooms,
            {
              group_id: room.group_id,
              room_id: room.id,
              room_name: room.room_name,
              room_no: room.room_no,
              room_type: room.room_type,
              room_rate_plan_id: room?.rate_plans
                ? room?.rate_plans[0]?.id
                : null,
              room_price: parseInt(room.room_amt),
              gst_rate: t_rate_amount.gstRate,
              gst_amt: t_rate_amount.gstAmount,
              is_tax_inclusive: false,
            },
          ],
        });
      }
      let rooms_f = form.getFieldValue("rooms") || [];
      rooms_f = rooms_f.filter((room) => Object.keys(room).length > 0);
      form.setFieldsValue({ rooms_f });
      if (!rooms_f.length) {
        handleAddRoom();
      }
      form.setFieldsValue({
        booking_segment: BUSINESS_SEGMENT[0].value,
        advance_amount: 0,
        checkin_date: checkin,
        checkout_date: checkout,
        country_id: countryID ?? 102,
      });
      getLocations(countryID ?? 102, stateID);
      setCheckinDate(checkin);
      setCheckoutDate(checkout);
      handleDateChange(checkin, checkout);
      getData();
    } else {
      getInitValue();
    }
    setLoading(false);
  }, [room, form]);

  const getData = () => {
    const checkin = date ? dayjs(date) : today;
    const checkout = date ? dayjs(date).add(1, "day") : today.add(1, "day");

    const formattedCheckIn = dayjs(checkinDate ?? checkin).format("D MMM YY");
    const formattedCheckOut = dayjs(checkoutDate ?? checkout).format(
      "D MMM YY",
    );

    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        groupRoomsByCategory(data["data"]["rooms"]);
        setLoading(false);
      } else {
        displayMessage(ERROR_MSG_TYPE, data.message);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setLoading(false);
    };
    postAPI(
      BOOKING_ROOMS,
      {
        start_date: formattedCheckIn,
        end_date: formattedCheckOut,
      },
      successFn,
      errorFn,
    );
  };

  const groupRoomsByCategory = (rooms) => {
    const grouped = rooms.reduce((acc, room) => {
      const category = room.room_category?.title || "Uncategorized";
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(room, ...room.similar_rooms);
      return acc;
    }, {});
    setRooms(grouped);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [roomServices, setRoomService] = useState(null);

  // Handle the "Add Room" button click
  const handleAddRoom = () => {
    setIsModalVisible(true); // Open modal
  };

  // Handle room selection
  const handleSelectRoom = (value) => {
    setSelectedRoom(value);
  };

  // Handle modal cancel
  const handleCancel = () => {
    setIsModalVisible(false); // Close modal without adding room
    setSelectedRoom(null);
  };

  // Handle modal ok (i.e., add the room to form)
  const handleOk = () => {
    if (selectedRoom) {
      const existingRooms = form.getFieldValue("rooms") || [];

      const isRoomAlreadyAdded = existingRooms.some(
        (room) => room.room_id === selectedRoom.id,
      );

      if (isRoomAlreadyAdded) {
        displayMessage(ERROR_MSG_TYPE, "This room is already added.");
        return;
      }

      if (selectedRoom?.rate_plans) {
        setRoomService((prev) => {
          const existingPlans = prev?.[selectedRoom.group_id] || [];

          const mergedPlans = [
            ...existingPlans,
            ...selectedRoom.rate_plans.filter(
              (newPlan) =>
                !existingPlans.some((oldPlan) => oldPlan.id === newPlan.id),
            ),
          ];

          return {
            ...(prev || {}),
            [selectedRoom.group_id]: mergedPlans,
          };
        });
      }

      const t_rate_amount = getGstRateAndAmount(
        selectedRoom.room_amt,
        totalDays,
      );

      form.setFieldsValue({
        rooms: [
          ...existingRooms,
          {
            group_id: selectedRoom.group_id,
            room_id: selectedRoom.id,
            room_name: selectedRoom.room_name,
            room_no: selectedRoom.room_no,
            room_type: selectedRoom.room_type,
            room_rate_plan_id: selectedRoom?.rate_plans[0]?.id ?? null,
            room_price: selectedRoom.room_amt,
            gst_rate: t_rate_amount.gstRate,
            gst_amt: t_rate_amount.gstAmount,
            is_tax_inclusive: false,
          },
        ],
      });

      let rooms = form.getFieldValue("rooms") || [];
      if (rooms.length > 0) {
        rooms = rooms.filter((room) => Object.keys(room).length > 0);
        form.setFieldsValue({ rooms });
      }

      setIsModalVisible(false);
      setSelectedRoom(null);
      handleDateChange(checkinDate ?? today, checkoutDate ?? today);
    }
  };

  const handleOnChange = (key, value) => {
    form.setFieldsValue({ [key]: value });
    if (key === "country_id") {
      setCountryID(value);
      getLocations(value, stateID);
    } else if (key === "state_id") {
      setStateID(value);
      getLocations(countryID, value);
    }
  };

  const getLocations = (countryID, stateID) => {
    setLoading(true);
    const successFn = function (data) {
      setCountry(data.countries);
      setState(data.states);
      setCity(data.cities);
      setLoading(false);
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    const url =
      LOCATIONS +
      (countryID ? countryID : "") +
      (stateID ? `&state_id=${stateID}` : "");
    getAPI(url, successFn, errorFn);
  };

  const props = {
    multiple: false,
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      const isAllowedType = allowedTypes.includes(file.type);

      if (!isAllowedType) {
        displayMessage(
          ERROR_MSG_TYPE,
          `${file.name} is not a valid image file (PNG, JPEG, JPG only)`,
        );
      } else {
        setFileList([file]);
      }

      return isAllowedType || Upload.LIST_IGNORE;
    },
    fileList,
  };

  const handleUploadDoc = async (value) => {
    try {
      setLoading(true);
      const data = new FormData();
      data.append("folder", "Customer-Document");
      Array.from(fileList).forEach((element) => {
        data.append("files[]", element);
      });
      data.append("tag", value.phone);

      const successFn = async function (data) {
        console.log("File to response=> " + data);
        if (data.status === true) {
          let docID = data.responses[0].id || null;
          displayMessage(SUCCESS_MESSAGE, data.message);
          if (docID !== null) {
            console.log("Old Doc ID: ", oldDocID);
            if (
              oldDocID !== undefined &&
              oldDocID !== null &&
              Number.isInteger(Number(oldDocID))
            ) {
              await deleteDoc({ id: oldDocID });
            }
            console.log("Doc Result: ", docID);
            value.id_card_image = docID;
            setImageUrl(data.responses[0].filePath);
            form.setFieldsValue({
              id_card_image: docID,
            });
            await submitForm(value);
          } else {
            setImageUrl(null);
            displayMessage(ERROR_MSG_TYPE, "Unable to Upload Document");
            return null;
          }
        } else {
          setImageUrl(null);
          displayMessage(ERROR_MSG_TYPE, data.message);
          return null;
        }
      };
      const errorFn = function () {
        setImageUrl(null);
        displayMessage(ERROR_MSG_TYPE, "Unable to Upload Document");
        return null;
      };
      postAPI(FILE_UPLOAD, data, successFn, errorFn);
    } catch (error) {
      setImageUrl(null);
      displayMessage(ERROR_MSG_TYPE, error.message);
      return null;
    }
  };

  const getUserDetail = (e) => {
    const mobile = e.target.value;
    if (mobile.length === 10) {
      setLoading(true);
      var data = new FormData();
      data.append("mobile", mobile);
      data.append("user_type", "customer");
      const successFn = function (data) {
        if (data.status === true) {
          if (
            data.user.image !== undefined &&
            data.user.image !== null &&
            data.user.image.filePath
          ) {
            setOldDocID(data.user.image.id ?? null);
            setImageUrl(data.user.image.filePath ?? null);
          }
          form.setFieldsValue({
            user_id: data.user.id || null,
            name: data.user.name,
            email: data.user.email,
            phone: data.user.phone,
            id_card_type: data.user.id_card_type ?? null,
            id_card_number: data.user.id_card_number ?? null,
            id_card_image: data.user.image?.id ?? null,
            address: data.user.address ?? null,
            country_id: data.user.country_id ?? 102,
            state_id: data.user.state_id ?? null,
            city_id: data.user.city_id ?? null,
          });
          setCountryID(data.user.country_id ?? 102);
          setStateID(data.user.state_id ?? null);
          getLocations(data.user.country_id ?? 102, data.user.state_id ?? null);
          setLoading(false);
        } else {
          form.setFieldsValue({
            user_id: null,
          });
          setLoading(false);
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
      };
      const errorFn = function (err) {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to Get Data" + err);
      };
      postAPI(USER_DETAIL_MOBILE, data, successFn, errorFn);
    }
  };

  const handleDateChange = (checkin, checkout) => {
    const checkinDate = checkin ? checkin.startOf("day") : null;
    const checkoutDate = checkout ? checkout.startOf("day") : null;

    setCheckinDate(checkinDate);
    setCheckoutDate(checkoutDate);

    getData();
    if (checkinDate && checkoutDate) {
      const diffInTime = checkoutDate.valueOf() - checkinDate.valueOf();
      const diffInDays = diffInTime / (1000 * 3600 * 24);

      const days = diffInDays === 0 ? 1 : diffInDays;

      console.log("Total Days: ", days);

      setTotalDays(days);
      let totalPrice = 0;
      const rooms = form.getFieldValue("rooms") || [];

      // Loop through each added room and calculate total price
      rooms.forEach((room) => {
        const roomTotalPrice = days * room.room_price;
        totalPrice += roomTotalPrice;

        console.log(`Total Price for Room ${room.room_no}: `, roomTotalPrice);
      });

      console.log("Total Amount for all rooms: ", totalPrice);
      calculateTotal();
    } else {
      setTotalAmount(0);
      form.setFieldsValue({
        sub_total_amount: 0,
        total_amount: 0,
        gst_amount: 0,
      });
    }
  };

  const handleAdvanceAmountChange = (value) => {
    const advanceAmount = parseFloat(value);

    if (advanceAmount > totalAmount) {
      form.setFields([
        {
          name: "advance_amount",
          errors: ["Advance amount cannot be greater than total amount."],
        },
      ]);
    } else {
      form.setFields([
        {
          name: "advance_amount",
          errors: [],
        },
      ]);
    }
  };

  const clearForm = () => {
    setTotalAmount(0);
    setCheckinDate(null);
    setCheckoutDate(null);
    setSelectedRoom(null);
    setFileList([]);
    setImageUrl(null);
    setOldDocID(null);
    form.resetFields();
    getInitValue();
  };

  const deleteDoc = async (value) => {
    console.log("Delete Doc: ", value);
    const successFn = function (data) {
      if (data.status === true) {
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
    };
    postAPI(FILE_DESTROY, value, successFn, errorFn);
  };

  const formHandle = async (value) => {
    if (fileList.length > 0) {
      await handleUploadDoc(value);
    } else {
      await submitForm(value);
    }
  };

  const submitForm = async (value) => {
    console.log("Submit Form: ", value);
    value.checkin_date = dayjs(value.checkin_date).add(330, "minutes");
    value.checkout_date = dayjs(value.checkout_date).add(330, "minutes");
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        clearForm();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
    };
    postAPI(CREATE_BOOKING, value, successFn, errorFn);
  };

  return (
    <Card
      loading={loading}
      title={
        <strong>
          Total Amount: {CURRENCY + gstBillSummery.summary.grandTotal}
          /-
        </strong>
      }
      extra={
        <Space>
          <Button
            loading={loading}
            onClick={() => {
              clearForm();
            }}
          >
            Clear
          </Button>
          <Button
            loading={loading}
            onClick={() => {
              form.submit();
            }}
            type="primary"
          >
            Submit
          </Button>
        </Space>
      }
    >
      <Form layout="vertical" form={form} onFinish={formHandle}>
        {/* Room Details Section */}
        <Title level={5}>Booking Details</Title>
        <Divider />
        <Form.Item name="booking_type" initialValue={booking_type} hidden />
        <Form.Item name="booking_source" initialValue="portal" hidden />
        {/* Dynamic Room List */}
        <Form.List
          name="rooms"
          initialValue={[{}]} // Initial value for the list
          rules={[
            {
              validator: async (_, rooms) => {
                if (!rooms || rooms.length < 1) {
                  return Promise.reject(
                    new Error("At least one room must be selected."),
                  );
                }
              },
            },
          ]}
        >
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, fieldId, ...restField }) => (
                <Row key={key} gutter={[16, 16]}>
                  <Form.Item {...restField} name={[name, "group_id"]} hidden>
                    <Input />
                  </Form.Item>
                  <Col span={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "room_name"]}
                      label="Room Name"
                      rules={[
                        {
                          required: true,
                          message: "Please select room name!",
                        },
                      ]}
                    >
                      <Input disabled placeholder="Room Name" />
                    </Form.Item>
                  </Col>

                  <Col span={2}>
                    <Form.Item {...restField} name={[name, "room_id"]} hidden />
                    <Form.Item
                      {...restField}
                      name={[name, "room_no"]}
                      label={"Room-No."}
                      rules={[
                        {
                          required: true,
                          message: "Please input room number!",
                        },
                      ]}
                    >
                      <Input disabled placeholder="Room Number" />
                    </Form.Item>
                  </Col>

                  <Col span={1}>
                    <Form.Item
                      {...restField}
                      name={[name, "room_type"]}
                      label="Type"
                      rules={[
                        {
                          required: true,
                          message: "Please select room type!",
                        },
                      ]}
                    >
                      <Input disabled placeholder="Room Type" />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      {...restField}
                      name={[name, "room_rate_plan_id"]}
                      label="Room Type"
                      rules={[
                        {
                          required: true,
                          message: "Please select room service!",
                        },
                      ]}
                    >
                      <Select
                        style={{ width: "100%" }}
                        options={
                          roomServices?.[
                            form.getFieldValue(["rooms", name, "group_id"])
                          ]?.map((item) => ({
                            label: `${getServiceLabel(item.room_service)} (${getRoomTypeLabel(item.room_type)})`,
                            value: item.id,
                          })) || []
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col span={2}>
                    <Form.Item
                      {...restField}
                      name={[name, "room_price"]}
                      label="Price"
                      rules={[
                        {
                          required: true,
                          message: "Please input room price!",
                        },
                      ]}
                    >
                      <Input placeholder="Price" />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "is_tax_inclusive"]}
                      valuePropName="checked"
                      label="-"
                    >
                      <Checkbox
                        onChange={(e) => {
                          const inclusive = e.target.checked;
                          const updatedRooms = [
                            ...(form.getFieldValue("rooms") || []),
                          ];
                          const room = updatedRooms[name];

                          if (!room || !room.room_price) return;

                          const days = totalDays || 1;

                          if (inclusive) {
                            // ✅ Inclusive calculation
                            const result = getInclusiveGstRateAndAmount(
                              room.room_price,
                              1,
                            );
                            room.room_price = result.baseAmount; // Base value
                            room.gst_rate = result.gstRate;
                            room.gst_amt = result.gstAmount;
                            room.is_tax_inclusive = true;
                          } else {
                            // ✅ Exclusive calculation
                            const result = getGstRateAndAmount(
                              room.room_price,
                              1,
                            );
                            room.gst_rate = result.gstRate;
                            room.gst_amt = result.gstAmount;
                            room.is_tax_inclusive = false;
                          }

                          updatedRooms[name] = room;
                          form.setFieldsValue({ rooms: updatedRooms });
                          calculateTotal();
                        }}
                      >
                        Price Inclusive
                      </Checkbox>
                    </Form.Item>
                  </Col>

                  <Col span={2}>
                    <Form.Item
                      {...restField}
                      name={[name, "gst_rate"]}
                      label="GST Rate"
                      rules={[
                        {
                          required: true,
                          message: "Please input room GST Rate!",
                        },
                      ]}
                    >
                      <Input disabled placeholder="GST Rate" />
                    </Form.Item>
                  </Col>

                  <Col span={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "gst_amt"]}
                      label="GST Amount"
                      rules={[
                        {
                          required: true,
                          message: "Please input GST Amount!",
                        },
                      ]}
                    >
                      <Input disabled placeholder="Price" />
                    </Form.Item>
                  </Col>

                  <Col span={2}>
                    <Form.Item>
                      <Button
                        danger
                        disabled={key === 0 && fields.length === 1}
                        onClick={() => {
                          remove(name);
                          handleDateChange(
                            checkinDate ?? today,
                            checkoutDate ?? today,
                          );
                        }}
                        icon={<CloseCircleFilled />}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              ))}
              <Form.Item>
                <Button
                  style={{ width: "100%" }}
                  type="dashed"
                  onClick={handleAddRoom}
                  icon={<PlusOutlined />}
                >
                  Add Room
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>

        {/* Modal for selecting room */}
        <Modal
          title="Select Room"
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          okText="Add Room"
          cancelText="Cancel"
        >
          {Object.keys(rooms).map((category) => (
            <div key={category}>
              <h3>
                <b>{category}</b>
              </h3>
              <Row gutter={16}>
                {rooms[category].map((room) => (
                  <Col span={12} key={room.id}>
                    <Button
                      block
                      onClick={() => handleSelectRoom(room)}
                      disabled={loading || selectedRoom?.id === room.id}
                    >
                      {room.name} ({room.room_no})
                    </Button>
                  </Col>
                ))}
              </Row>
              <Divider />
            </div>
          ))}
        </Modal>
        {/* Check-in / Check-out and Advance Section */}
        <Row gutter={[16, 16]}>
          <Col span={2.5}>
            <Form.Item
              name="checkin_date"
              label="Check-in Date"
              rules={[
                {
                  required: true,
                  message: "Please select the check-in date",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                value={checkinDate}
                onChange={(date) => handleDateChange(date, checkoutDate)}
                disabledDate={(current) =>
                  current && current < new Date().setHours(0, 0, 0, 0)
                }
              />
            </Form.Item>
          </Col>

          <Col span={2.5}>
            <Form.Item
              name="checkout_date"
              label="Check-out Date"
              rules={[
                {
                  required: true,
                  message: "Please select the check-out date",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                value={checkoutDate}
                onChange={(date) => handleDateChange(checkinDate, date)}
                disabledDate={(current) => current && current < checkinDate}
              />
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
              name="booking_segment"
              label="Business Segment"
              rules={[
                {
                  required: true,
                  message: "Please select the Business Segment",
                },
              ]}
            >
              <Select
                placeholder="Select Business Segment"
                options={BUSINESS_SEGMENT}
              />
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
              name="sub_total_amount"
              label="Sub Total Amount"
              rules={[
                {
                  required: true,
                  message: "Please enter the Sub Total amount",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Sub Total Amount"
                min={0}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item
              name="gst_amount"
              label="Total GST Amount"
              rules={[
                {
                  required: true,
                  message: "Please enter the Total GST amount",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Total GST Amount"
                min={0}
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
              name="total_amount"
              label="Total Amount"
              rules={[
                {
                  required: true,
                  message: "Please enter the Total amount",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Total Amount"
                min={0}
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
              name="advance_amount"
              label="Advance Amount"
              rules={[
                {
                  required: true,
                  message: "Please enter the advance amount",
                },
                {
                  pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
                  message:
                    "Please enter a valid advance amount (e.g., 1000, 1000.50)",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Advance Amount"
                min={0}
                onChange={(e) => handleAdvanceAmountChange(e.target.value)}
                onBlur={() => form.validateFields(["advance_amount"])}
              />
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item name="adv_payment_method" label="Payment Method">
              <Select
                style={{ width: "100%" }}
                options={PAYMENT_METHOD.map((method) => ({
                  ...method,
                  disabled: method.value === "razorpay",
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <Form.Item
              name="booking_referred_name"
              label="Referred Name"
              rules={[
                {
                  required: false,
                  message: "Enter the Referred Name",
                },
              ]}
            >
              <Input placeholder="Referred Name" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="customer_gst_no"
              label="GST No"
              rules={[
                {
                  required: false,
                  message: "Enter the GST No",
                },
              ]}
            >
              <Input placeholder="GST No" />
            </Form.Item>
          </Col>
        </Row>

        <Divider />
        {/* Customer Details Section */}
        <Title level={5}>Customer Details</Title>
        <Divider />
        <Row gutter={[16, 16]}>
          <Col span={18}>
            <Row gutter={[16, 16]}>
              <Form.Item name="user_id" hidden />
              <Col span={8}>
                <Form.Item
                  name="phone"
                  label="Mobile"
                  onChange={getUserDetail}
                  rules={[
                    {
                      required: true,
                      message: "Please enter the customer's mobile number",
                    },
                  ]}
                >
                  <Input placeholder="Mobile Number" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the customer's name",
                    },
                  ]}
                >
                  <Input placeholder="Customer Name" />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: false,
                      message: "Please enter the customer's email",
                    },
                    {
                      type: "email",
                      message: "Please enter a valid email",
                    },
                  ]}
                >
                  <Input placeholder="Customer Email" />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="country_id"
                  label="Country"
                  rules={[
                    {
                      required: false,
                      message: "Please select the country",
                    },
                  ]}
                >
                  <Select
                    loading={loading}
                    placeholder="Select Country"
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) => handleOnChange("country_id", value)}
                    options={
                      country &&
                      country.map((e) => ({
                        value: e.id,
                        label: e.name,
                      }))
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="state_id"
                  label="State"
                  rules={[
                    {
                      required: false,
                      message: "Please select the State",
                    },
                  ]}
                >
                  <Select
                    loading={loading}
                    disabled={countryID === null || state === null}
                    placeholder="Select State"
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) => handleOnChange("state_id", value)}
                    options={
                      state &&
                      state.map((e) => ({
                        value: e.id,
                        label: e.name,
                      }))
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="city_id"
                  label="City"
                  rules={[
                    {
                      required: false,
                      message: "Please select the City",
                    },
                  ]}
                >
                  <Select
                    loading={loading}
                    disabled={stateID === null || city === null}
                    placeholder="Select City"
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) => handleOnChange("city_id", value)}
                    options={
                      city &&
                      city.map((e) => ({
                        value: e.id,
                        label: e.name,
                      }))
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="address"
                  label="Address"
                  rules={[
                    {
                      required: false,
                      message: "Please enter the address",
                    },
                  ]}
                >
                  <Input.TextArea rows={4} placeholder="Customer Address" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={6}>
            <Form.Item
              name="id_card_type"
              label="ID Card Type"
              rules={[
                {
                  required: false,
                  message: "Please select the ID card type",
                },
              ]}
            >
              <Select placeholder="Select ID Card Type">
                <Option value="passport">Passport</Option>
                <Option value="aadhaar">Aadhaar</Option>
                <Option value="drivingLicense">Driving License</Option>
                <Option value="voterId">Voter ID</Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="id_card_number"
              label="ID Card Number"
              rules={[
                {
                  required: false,
                  message: "Please enter the ID card number",
                },
              ]}
            >
              <Input placeholder="ID Card Number" />
            </Form.Item>

            <Form.Item
              name="id_card_image"
              label="ID Card Image"
              rules={[
                {
                  required: false,
                  message: "Please enter the ID card image",
                },
              ]}
            >
              <Row gutter={[16, 16]}>
                {imageUrl ? (
                  <Col span={12}>
                    <img
                      alt="doc-image"
                      src={IMAGE_BASE_URL + imageUrl}
                      height={150}
                      width={150}
                    />
                  </Col>
                ) : null}
                <Col span={imageUrl ? 12 : 24}>
                  <Dragger {...props}>
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                  </Dragger>
                </Col>
              </Row>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default ReservationForm;
